export default "__VITE_ASSET__CT8qL6Sp__"